<template>
  <div>
    <div style="display: flex; align-items: flex-start">
      <sidebar style="margin-right: 20px; max-width: 200px" />
      <el-card style="width: 100%">
        <div
          slot="header"
          class="clearfix"
        >
          <span>Szolgáltatások</span>
          <el-button
            style="float: right; margin-top: -5px;"
            type="success"
            size="small"
            @click="$router.replace('/data/services/services/add')"
            icon="el-icon-plus"
            v-can="'data.service.create'"
          >
            Új Szolgáltatás
          </el-button>
        </div>
        <table-filter v-if="config"
          :config="config"
          action="service/fetchAll" />
        <list />
        <template v-if="$route.meta.showAddServiceDialog">
          <service-dialog
            type="add"
          />
        </template>
        <template v-if="$route.meta.showUpdateServiceDialog">
          <service-dialog
            :serviceId="$route.params.id"
            type="update"
          />
        </template>
      </el-card>
    </div>
  </div>
</template>
<script>
  import Sidebar from '../../../components/data/services/Sidebar';
  import List from '../../../components/data/services/services/List';
  import ServiceDialog from '../../../components/data/services/services/Dialog';
  import TableFilter from '../../../components/TableFilter';

  export default {
    components: {
      Sidebar,
      List,
      ServiceDialog,
      TableFilter,
    },
    data() {
      return {
        config: null,
      };
    },
    methods: {
      async setConfig() {
        let serviceCategories = this.$store.getters['serviceCategory/serviceCategories'];
        let vats = this.$store.getters['vat/vats'];
        let glaNumbers = this.$store.getters['glaNumber/glaNumbers'];
        if (!serviceCategories.length) {
          await this.$store.dispatch('serviceCategory/fetchAll');
          serviceCategories = this.$store.getters['serviceCategory/serviceCategories'];
        }
        if (!vats.length) {
          await this.$store.dispatch('vat/fetchAll');
          vats = this.$store.getters['vat/vats'];
        }
        if (!glaNumbers.length) {
          await this.$store.dispatch('glaNumber/fetchAll');
          glaNumbers = this.$store.getters['glaNumber/glaNumbers'];
        }
        this.config = [
          {
            type: 'text',
            name: 'name',
            label: 'Név',
            defaultSearch: true
          },
          {
            type: 'select',
            name: 'category_id',
            options: serviceCategories,
            label: 'Kategória',
            labelCallback: category => category && `${category.name}` || '',
            valueKey: 'id',
          },
          {
            type: 'select',
            name: 'vat_id',
            options: vats,
            label: 'Áfa',
            labelCallback: vat => vat && `${vat.value}%` || '',
            valueKey: 'id',
          },
          {
            type: 'text',
            name: 'registration_number',
            label: 'Szj szám',
          },
          {
            type: 'select',
            name: 'status',
            options: [
              { label: 'Aktív', status: 'active' },
              { label: 'Inaktív', status: 'inactive' },
            ],
            label: 'Státusz',
            labelCallback: status => status.label,
            valueKey: 'status',
          },
          {
            type: 'select',
            name: 'gla_number_id',
            label: 'Főkönyvi szám',
            options: glaNumbers,
            labelCallback: vat => vat && `${vat.value}` || '',
            valueKey: 'id',
          }
        ];
      }
    },
    async mounted() {
      await this.setConfig();
    }
  };
</script>
